import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { MerakiNetwork } from '@app/shared/models/meraki/meraki-network.model';
import { MerakisService } from '@app/features/merakis/shared/merakis.service';


@Component({
    selector: 'app-network-tags',
    templateUrl: './network-tags.component.html',
    styleUrls: ['./network-tags.component.css'],
    standalone: false
})
export class NetworkTagsComponent implements OnInit, OnDestroy {

    isLoading = false;
    storeNumber: string;
    network = null;
    networkTags: string;

    constructor(
        private mearkisService: MerakisService
    ) {}

    ngOnInit() {}
    ngOnDestroy() {}

    getRestaurantNetwork() {
        this.isLoading = true;
        this.resetView();
        Promise.all(
          [
            this.getNetwork()
          ]
        ).then(() => {
          this.isLoading = false;
        })
    }

    getNetwork() {
      this.isLoading = true;
      const promise = new Promise((resolve, reject) => {
          this.mearkisService.getNetwork(this.storeNumber).then(response => {
            response.toPromise().then(network_from_response => {
              try {
                  let network: MerakiNetwork = network_from_response["message"];
                  this.network = network;
                  this.networkTags = network.tags;
              } catch (error) {
                console.log("Meraki network timed out!")
                this.isLoading = false;
              } finally {
                resolve(true);
                this.isLoading = false;
              }
            });
          });
        });
        return promise;
    }

    updateNetworkTags() {
      this.isLoading = true;
      const promise = new Promise((resolve, reject) => {
        this.mearkisService.updateNetworkTags(this.network.id, this.networkTags).then(response => {
          response.toPromise().then(network_from_response => {
            try {
                let network: MerakiNetwork = network_from_response["message"];
                this.network = network;
                this.networkTags = network.tags;
            } catch (error) {
              console.log("Meraki network timed out!")
            } finally {
              resolve(true);
              this.isLoading = false;
            }
          });
        });
      });
  
      return promise;
    }

    resetView() {
        this.network = null
    }

}